/* MOMENTUM theme scripts */
(function () {
  'use strict';
  var M = window.MOMENTUM || {};
  var BRAND = (M.brand || 'MOMENTUM').toUpperCase();

  /* ---------------- helpers ---------------- */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  /* ---------------- events page filters ----------------
     Cards are rendered by Liquid; this only shows/hides them. */
  function initEventsPage() {
    var root = $('[data-events-page]');
    if (!root) return;
    var groups = { upcoming: $('[data-events-group="upcoming"]', root), past: $('[data-events-group="past"]', root) };
    var none = $('[data-events-none]', root);
    var qIn = $('[name="q"]', root), stSel = $('[name="state"]', root), citySel = $('[name="city"]', root), catSel = $('[name="category"]', root);
    var allCities = $$('option', citySel).slice(1).map(function (o) { return o.value; });
    var cards = $$('[data-event]', root);
    var view = new URLSearchParams(location.search).get('view') === 'past' ? 'past' : 'upcoming';
    root.classList.add('is-filtering');

    function fillCities() {
      var st = stSel.value, keep = citySel.value;
      var ok = allCities.filter(function (c) {
        return !st || cards.some(function (k) { return k.getAttribute('data-city') === c && k.getAttribute('data-state') === st; });
      });
      citySel.innerHTML = '<option value="">All Cities</option>' + ok.map(function (c) {
        return '<option value="' + c.replace(/"/g, '&quot;') + '">' + c.replace(/</g, '&lt;') + '</option>';
      }).join('');
      citySel.value = ok.indexOf(keep) > -1 ? keep : '';
    }
    function draw() {
      $$('[data-view]', root).forEach(function (b) {
        var on = b.getAttribute('data-view') === view;
        b.classList.toggle('is-active', on); b.setAttribute('aria-selected', on);
      });
      Object.keys(groups).forEach(function (k) { if (groups[k]) groups[k].hidden = k !== view; });
      var g = groups[view], q = qIn.value.trim().toLowerCase(), shown = 0;
      $$('[data-event]', g).forEach(function (c) {
        var ok = (!stSel.value || c.getAttribute('data-state') === stSel.value) &&
          (!citySel.value || c.getAttribute('data-city') === citySel.value) &&
          (!catSel.value || c.getAttribute('data-category') === catSel.value) &&
          (!q || (c.getAttribute('data-search') || '').indexOf(q) > -1);
        c.hidden = !ok; if (ok) shown++;
      });
      var total = $$('[data-event]', g).length;
      var empty = $('.empty-state', g);
      if (none) none.hidden = !(total > 0 && shown === 0);
      if (empty) empty.hidden = total > 0;
      reveal();
    }
    $$('[data-view]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        view = b.getAttribute('data-view');
        var u = new URL(location.href);
        if (view === 'past') u.searchParams.set('view', 'past'); else u.searchParams.delete('view');
        history.replaceState(null, '', u);
        draw();
      });
    });
    qIn.addEventListener('input', draw);
    stSel.addEventListener('change', function () { fillCities(); draw(); });
    citySel.addEventListener('change', draw);
    catSel.addEventListener('change', draw);
    $('[data-reset]', root).addEventListener('click', function () {
      qIn.value = ''; stSel.value = ''; catSel.value = ''; fillCities(); draw();
    });
    draw();
  }

  /* ---------------- add to calendar (.ics) ---------------- */
  function initIcs() {
    $$('[data-ics]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        if (!window.Blob) return; // falls back to Google Calendar link
        ev.preventDefault();
        function z(ts) { return new Date(ts * 1000).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); }
        function t(s) { return String(s || '').replace(/([,;\\])/g, '\\$1').replace(/\n/g, '\\n'); }
        var d = a.dataset;
        var lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//' + BRAND + '//Events//EN', 'BEGIN:VEVENT',
          'UID:' + d.handle + '@' + location.hostname, 'DTSTAMP:' + z(Date.now() / 1000), 'DTSTART:' + z(+d.start), 'DTEND:' + z(+d.end),
          'SUMMARY:' + t(d.title), 'DESCRIPTION:' + t(d.summary), 'LOCATION:' + t(d.location), 'URL:' + location.href.split('?')[0],
          'END:VEVENT', 'END:VCALENDAR'];
        var url = URL.createObjectURL(new Blob([lines.join('\r\n')], { type: 'text/calendar' }));
        var link = document.createElement('a');
        link.href = url; link.download = (d.handle || 'event') + '.ics';
        document.body.appendChild(link); link.click(); link.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
      });
    });
  }

  /* ---------------- header ---------------- */
  function initHeader() {
    $$('.nav-dd').forEach(function (dd) {
      var btn = $('button', dd);
      btn.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var open = dd.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open);
      });
    });
    document.addEventListener('click', function () { $$('.nav-dd.is-open').forEach(function (d) { d.classList.remove('is-open'); }); });
    var t = $('[data-menu-toggle]'), mn = $('[data-mobile-nav]');
    if (t && mn) t.addEventListener('click', function () {
      var open = mn.classList.toggle('is-open');
      t.setAttribute('aria-expanded', open);
      t.innerHTML = open ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>' : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M4 6h16M4 12h16M4 18h16"/></svg>';
    });
  }

  /* ---------------- cart ---------------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
  }
  function initProductForms() {
    $$('[data-product-form]').forEach(function (form) {
      var dataEl = $('[data-variants]', form.closest('[data-product]'));
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var idInput = $('input[name="id"]', form);
      var btn = $('[data-add]', form);
      var msg = $('[data-msg]', form);
      var priceEl = $('[data-price]', form.closest('[data-product]'));
      var root = form.closest('[data-product]');

      function selected() {
        return $$('[data-option-group]', root).map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
      }
      function sync() {
        var sel = selected();
        var v = variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] == null || o === sel[i]; }); })[0];
        // mark unavailable values for the last option
        $$('[data-option-group]', root).forEach(function (g, gi) {
          $$('input', g).forEach(function (inp) {
            var test = sel.slice(); test[gi] = inp.value;
            var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
            inp.classList.toggle('is-unavailable', !ok);
          });
        });
        if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-label') : 'Sold Out';
        if (priceEl) priceEl.innerHTML = v.price + (v.compare ? ' <s>' + v.compare + '</s>' : '');
        if (v.image) {
          var main = $('[data-main-img]', root);
          if (main) { main.src = v.image; main.removeAttribute('srcset'); }
        }
        var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      }
      $$('[data-option-group] input', root).forEach(function (i) { i.addEventListener('change', sync); });
      if (variants.length) sync();

      form.addEventListener('submit', function (ev) {
        if (!window.fetch) return;
        ev.preventDefault();
        btn.disabled = true; var label = btn.getAttribute('data-label'); btn.textContent = 'Adding…';
        msg.textContent = ''; msg.className = 'form-msg';
        fetch((M.routes && M.routes.cartAdd || '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || 'Could not add to cart.');
            btn.textContent = 'Added ✓';
            return fetch((M.routes && M.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
          })
          .catch(function (err) { msg.textContent = err.message; msg.className = 'form-msg form-msg--error'; btn.textContent = label; })
          .finally(function () { setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1400); });
      });
    });
    $$('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var main = $('[data-main-img]');
        main.src = t.getAttribute('data-thumb'); main.removeAttribute('srcset');
        $$('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === t); });
      });
    });
  }

  /* ---------------- collection chips ---------------- */
  function initChips() {
    $$('[data-chips]').forEach(function (wrap) {
      var grid = $(wrap.getAttribute('data-chips'));
      $$('.chip', wrap).forEach(function (c) {
        c.addEventListener('click', function () {
          var t = c.getAttribute('data-type');
          $$('.chip', wrap).forEach(function (x) { x.classList.toggle('is-active', x === c); });
          $$('[data-type]', grid).forEach(function (card) { card.hidden = t && card.getAttribute('data-type') !== t; });
        });
      });
    });
  }

  /* ---------------- gallery ---------------- */
  function initGallery() {
    var lb = $('[data-lightbox]');
    if (!lb) return;
    var img = $('img', lb), cap = $('.lightbox__caption', lb), list = [], idx = 0;
    function show() { img.src = list[idx].src; img.alt = list[idx].alt || ''; cap.textContent = list[idx].alt || ''; }
    function open(items, i) { list = items; idx = i || 0; show(); lb.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() { lb.classList.remove('is-open'); document.body.style.overflow = ''; }
    $('.lightbox__close', lb).addEventListener('click', close);
    $('.lightbox__prev', lb).addEventListener('click', function () { idx = (idx - 1 + list.length) % list.length; show(); });
    $('.lightbox__next', lb).addEventListener('click', function () { idx = (idx + 1) % list.length; show(); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') $('.lightbox__next', lb).click();
      if (e.key === 'ArrowLeft') $('.lightbox__prev', lb).click();
    });
    $$('[data-album]').forEach(function (a) {
      a.addEventListener('click', function () {
        var items = JSON.parse($('script', a).textContent);
        if (items.length) open(items, 0);
      });
    });
    $$('[data-lightbox-group]').forEach(function (g) {
      var btns = $$('[data-lb-src]', g);
      var items = btns.map(function (b) { return { src: b.getAttribute('data-lb-src'), alt: b.getAttribute('data-lb-alt') }; });
      btns.forEach(function (b, i) { b.addEventListener('click', function () { open(items, i); }); });
    });
    var gf = $('[data-gallery-filters]');
    if (gf) {
      var s = $('[name="state"]', gf), t = $('[name="type"]', gf);
      function apply() {
        $$('[data-album]').forEach(function (a) {
          a.hidden = (s.value && a.getAttribute('data-state') !== s.value) || (t.value && a.getAttribute('data-kind') !== t.value);
        });
      }
      s.addEventListener('change', apply); t.addEventListener('change', apply);
      $('[data-reset]', gf).addEventListener('click', function () { s.value = ''; t.value = ''; apply(); });
    }
  }

  /* ---------------- motion ---------------- */
  var ANIM = document.documentElement.classList.contains('anim');

  // Tag elements across every section so no Liquid edits are needed.
  var AUTO = {
    fade: [
      '.section-head', '.next-meet > .container > .eyebrow',
      '.page-head .container > *', '.page-head--dark .container > *',
      '.split > div:not(.split__img) > *',
      '.next-meet__grid > div:not(.next-meet__img) > *',
      '.chips', '.events-filters', '.gallery-filters',
      '.pdp > div:last-child > *', '.event-layout > div > *', '.event-side',
      '.sponsor-form', '.empty-state', '.social-row', '.recap-box',
      '.footer-grid > *', '.footer-bottom'
    ],
    stagger: [
      '.product-grid > *', '.event-grid > *', '.tiles > *', '.gallery-grid > *',
      '.album-grid > *', '.pillars > *', '.card-grid-2 > *', '.cart-item'
    ],
    img: ['.split__img', '.next-meet__img', '.wide-img', '.pdp__main']
  };
  function tag() {
    if (!ANIM) return;
    AUTO.fade.concat(AUTO.stagger).forEach(function (s) {
      $$(s).forEach(function (el) { if (!el.hasAttribute('data-reveal')) el.setAttribute('data-reveal', ''); });
    });
    AUTO.img.forEach(function (s) { $$(s).forEach(function (el) { el.setAttribute('data-reveal', 'img'); }); });
  }

  // Elements that enter together get a short cascade; later rows start fresh.
  var io = ('IntersectionObserver' in window && ANIM) ? new IntersectionObserver(function (entries) {
    // Already scrolled past (e.g. restored scroll position): show without animating.
    entries.forEach(function (en) {
      if (!en.isIntersecting && en.boundingClientRect.bottom < 0) {
        en.target.style.transition = 'none';
        en.target.querySelectorAll('img').forEach(function (i) { i.style.setProperty('transition', 'none', 'important'); });
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
    var batch = entries.filter(function (en) { return en.isIntersecting; })
      .sort(function (a, b) {
        var ra = a.boundingClientRect, rb = b.boundingClientRect;
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
    batch.forEach(function (en, i) {
      en.target.style.setProperty('--d', Math.min(i, 6) * 90 + 'ms');
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;

  function reveal() {
    tag();
    $$('[data-reveal]:not(.is-in)').forEach(function (el) { io ? io.observe(el) : el.classList.add('is-in'); });
  }

  // Parallax hero + header state, one rAF per frame, transforms only.
  function initScrollFx() {
    var heroMedia = $('.hero__media'), heroContent = $('.hero__content'), hero = $('.hero');
    var evImg = $('.event-hero > img');
    var root = document.documentElement, ticking = false;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    function frame() {
      ticking = false;
      var y = window.scrollY || 0;
      root.classList.toggle('is-scrolled', y > 8);
      if (!ANIM || reduce) return;
      if (hero && heroMedia) {
        var h = hero.offsetHeight || 1;
        if (y < h) {
          heroMedia.style.setProperty('--py', (y * 0.32).toFixed(1) + 'px');
          heroContent && heroContent.style.setProperty('--fade', Math.max(0, 1 - y / (h * 0.7)).toFixed(3));
        }
      }
      if (evImg && y < 700) evImg.style.setProperty('--py', (y * 0.3).toFixed(1) + 'px');
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }, { passive: true });
    frame();
  }

  function init() {
    initHeader();
    initEventsPage();
    initIcs();
    initProductForms();
    initChips();
    initGallery();
    initScrollFx();
    reveal();
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () { initEventsPage(); initIcs(); initGallery(); reveal(); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
